import Vue from 'vue'
import 'es6-promise/auto'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: {
      loggedIn: true,
      userData: {
        name: 'kikutnik666',
        age: 30
      },
      userContact: {
        email: 'kamilrogala@gmail.com',
        phone: '605163399'
      },
      userAddr: {
        city: 'Płochocin',
        postalCode: '05-860',
        street: 'Łąkowa',
        buildingNumber: '16c',
        homeNumber: '18'
      }
    },
    count: 0
  },
  mutations: {
    incrementStore: function (state) {
      state.count++
      console.log(state.count)
    },
    decrementStore: function (state) {
      state.count--
      console.log(state.count)
    }
  },
  getters: {
    countItems: state => {
      return state.count
    }
  }
})

/**
 * wspólne skrypty aplikacji
 */

const devStorage = sessionStorage

export function isLogged () {
  if (devStorage.getItem('token') === 'true') return true
  return false
}

export function isAdmin () {
  if (devStorage.getItem('admin') === 'true') return true
  return false
}

export function moveArrayEl (array, from, to) {
  return array.splice(to, 0, array.splice(from, 1)[0])
}
